<template>

    <div class="main">

        <!-- 資料讀取中 -->
        <div id="mask" class="hide">
            <div class="text">
                <i class="fas fa-spinner fa-pulse"></i> 資料讀取中
            </div>
        </div>
        <!-- 標題 -->
        <div class="main-title">
            <b-row align-h="between">
                <b-col cols="auto"><h2 class="px-3">{{ title }}</h2></b-col>
                <b-col cols="auto" align-self="center"><b-breadcrumb :items="items"></b-breadcrumb></b-col>
            </b-row>
        </div>
        <!-- 實際頁面 -->
        <div class="main-content" v-if="!isDevelop">

            <!-- 領取獎勵 -->
            <div id="award_form">

                <!-- 可以領取 --->
                <div class="w3-container page" v-show="isExist && isCanAward && !isAwardDone">
                    <div class="w3-card-4 w3-dark-grey form-style">
                
                        <div class="w3-container w3-center">
                            <!-- 標頭 -->
                            <p class="header-title">
                                {{ award.titleCanAward }}
                            </p>
                            <!-- 圖片 -->
                            <img class="img-body w3-circle w3-margin-top" src="/static/img/coin.png" alt="Avatar">
                            <!-- 描述 -->
                            <p class="description">
                                {{ award.descriptCanAward }}
                            </p>
                            <!-- 輸入農會代碼 -->
                            <div class="w3-col" style="width:50px">
                                <i class="w3-xxlarge fa fa-home"></i>
                            </div>
                            <div class="w3-rest">
                                <input class="w3-input w3-border" v-model="award.valueOffCode" type="text" :placeholder="award.placeholderOffCode" :disabled="award.disabledOffCode">
                            </div>
                            <!-- 領取獎勵按鈕 -->
                            <p style="margin-top: 10px;margin-bottom: 10px;">
                                <button class="w3-button w3-block w3-amber" @click="onReceive">
                                    <i class="fa" :class="button.classReceive" aria-hidden="true"></i> {{ button.labelReceive }}
                                </button>
                            </p>
                        </div>
                
                    </div>
                </div>
                <!-- 領取成功 --->
                <div class="w3-container page" v-show="isExist && isCanAward && isAwardDone">
                    <div class="w3-card-4 w3-dark-grey form-style">
                
                        <div class="w3-container w3-center">
                            <!-- 標頭 -->
                            <p class="header-title">
                                {{ award.titleAwardDone }}
                            </p>
                            <!-- 圖片 -->
                            <img class="img-body w3-circle w3-margin-top" src="/static/img/ok.png" alt="Avatar">
                            <!-- 描述 -->
                            <p class="description">
                                {{ award.descriptAwardDone }}
                            </p>
                        </div>
                
                    </div>
                </div>
                <!-- 不可領取 --->
                <div class="w3-container page" v-show="isExist && !isCanAward">
                    <div class="w3-card-4 w3-dark-grey form-style">
                
                        <div class="w3-container w3-center">
                            <!-- 標頭 -->
                            <p class="header-title">
                                {{ award.titleReceivedAward }}
                            </p>
                            <!-- 圖片 -->
                            <img class="img-body w3-circle w3-margin-top" src="/static/img/received.png" alt="Avatar">
                            <!-- 描述 -->
                            <p class="description">
                                {{ award.descriptReceivedAward }}
                            </p>
                        </div>
                
                    </div>
                </div>

                <!-- 不存在 --->
                <div class="w3-container page" v-show="!isExist">
                    <div class="w3-card-4 w3-dark-grey form-style">
                
                        <div class="w3-container w3-center">
                            <!-- 標頭 -->
                            <p class="header-title">
                                {{ award.titleNotExist }}
                            </p>
                            <!-- 圖片 -->
                            <img class="img-body w3-circle w3-margin-top" src="/static/img/not_valid.png" alt="Avatar">
                            <!-- 描述 -->
                            <p class="description">
                                {{ award.descriptNotExist }}
                            </p>
                        </div>
                
                    </div>
                </div>

            </div>
        </div>
        <!-- 開發頁面 -->
        <div class="main-content" v-if="isDevelop">

            <!-- 網頁施工中 -->
            <div id="award_form">
                目前該頁面在施工中，尚未完成。
            </div>

        </div>
    </div>
    
</template>
<script>

    export default {
        data() {
            return {

                //api 確認QrCode
                apiCheckQrCode: (data) => this.userRequest.post("/API/Default/CheckQrCode", data),          
                //api 領取獎勵
                apiReceivedAward: (data) => this.userRequest.post("/API/Default/ReceivedAward", data),
                //標題
                title:"兌換獎賞",
                //導覽列
                items: [
                    {
                        text: '首頁',
                        href: '#/'
                    },
                    {
                        text: '兌換獎賞',
                        active: true
                    }
                ],

                //是否是在開發模式
                isDevelop:false,
                //是否存在(系統是否存在這筆QrCode)
                isExist:false,
                //是否可以兌換(true-表示尚未兌換過，可以兌換)
                isCanAward:false,
                //是否兌換成功
                isAwardDone:false,
                //可以領取頁面
                award:{

                    //QrCode存在，尚未兌換
                    titleCanAward:"領取獎勵",
                    descriptCanAward:"尚未領取獎勵，請農會人員輸入您的農會代碼後，點選按鈕兌換獎賞。",
                    
                    //QrCode存在，成功兌換
                    titleAwardDone:"領取獎勵",
                    descriptAwardDone:"已完成兌換，請農會贈與該農戶相關贈品。",

                    //QrCode存在，已經兌換
                    titleReceivedAward:"領取獎勵",
                    descriptReceivedAward:"已領取獎勵，無法再次領取。",

                    //QrCode不存在
                    titleNotExist:"領取獎勵",
                    descriptNotExist:"無效，請確認QrCode是否正確?",
                    
                    labelOffCode: "農會代碼:",
                    valueOffCode: "",
                    classOffCode: "fa-user",
                    placeholderOffCode: "請輸入農會代碼",
                    disabledOffCode:false,
                },
                //相關按鈕
                button:{

                    labelReceive: "領取獎勵",
                    classReceive:"fa-money",
                },
                //訊息
                message:{
                    noeExistOffCode:"無效的農會代碼，請確認農會代碼是否輸入正確?",            
                },
            }
        },
        watch: {

        },
        mounted(){

            window.vue = this;  //在created方法中，將變數全局化，主控台可用 window.vue._data 調閱或呼叫(若不用可以直接遮罩)
                                //例如:window.vue._data.map.getCesiumScene().setEnabled(false);
            this.checkQrCode();
        },
        created() {
               
        },
        destroyed() {

        },
        methods: {

            //啟用遮罩
            enableDefaultLoad:function()
            {
                this.enableMask();
                this.default_load = true;
            },
            //取消遮罩
            disableDefaultLoad:function()
            { 
                //暫時先設定延遲，否則watch會重複觸發
                const _this = this;
                window.ThreadTool.Delay(function(){
                
                    _this.disableMask();
                    _this.default_load = false;

                },this.delay_ms_api);
            },            
            //確認QrCode
            checkQrCode:function(){

                this.enableDefaultLoad(); 
                this.apiCheckQrCode({

                    QrCode:this.getQrcode(),
                })
                .then((res)=>{

                    const json = JSON.parse(res.data);
                    window.vue.isExist = json.isExist;
                    window.vue.isCanAward = json.isCanAward;
                    window.vue.disableDefaultLoad();
                })
                .catch((err)=> {
                    console.log(err);
                    window.vue.disableDefaultLoad();
                }); 
            },
            //領取獎勵
            receivedAward:function(){

                this.enableDefaultLoad(); 
                this.apiReceivedAward({

                    QrCode:this.getQrcode(),
                    OfficeCode:this.award.valueOffCode,
                })
                .then((res)=>{

                    const json = JSON.parse(res.data);
                    console.log(json);
                    if(json.State)
                    {
                        this.isAwardDone = true;
                        alert(json.Message);
                    }
                    else
                    {
                        alert(json.Message);
                    }
                    window.vue.disableDefaultLoad();
                })
                .catch((err)=> {
                    console.log(err);
                    window.vue.disableDefaultLoad();
                }); 
            },

            //領取獎勵
            onReceive:function()
            {
                if(this.award.valueOffCode == ""){  alert(this.getPleaseEnterField("農會代碼")); return false; }
                this.receivedAward();                
            },
            //取得QrCode
            getQrcode:function(){

                var temp = location.hash.split("qr_code=");
                var qr_code = "";
                if(temp.length > 1)
                {
                    qr_code = temp[1];
                }
                return qr_code;
            },

            //取得使用者Xxx欄位未輸入訊息
            getPleaseEnterField: function(ParamName) { return "請輸入【" + ParamName + "】！"; },
            //取得使用者Xxx欄位未選擇訊息
            getPleaseChooseField: function(ParamName) { return "請選擇【" + ParamName + "】！"; },
            //取得使用者Xxx欄位為空訊息
            getErrorMessageParamEmpty: function(ParamName) { return "操作失敗，【" + ParamName + "】不可為空！"; },
        },
    }

</script>
<style scoped>

/** 兌換表單 */
#award_form
{
    text-align: -webkit-center;
}

#award_form .page
{
    max-width: 450px; 
}


/** 公用表單畫面 */
.form-style
{
    min-height: 360px;
}
/** 公用表單畫面-標頭 */
.form-style .header-title
{
    margin-top: 30px !important;
    font-weight: bold;
    font-size: 1.75rem;
}
/** 公用表單畫面-圖片 */
.form-style .img-body
{
    width:30%;
    min-width: 150px !important;
}
/** 公用表單畫面-描述 */
.form-style .description
{
    margin-top: 20px !important;
    font-size: 1.2rem;
}

</style>